import React, { memo, useState } from 'react';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Tooltip from '@mui/material/Tooltip';

import { useLanguage } from '../../hooks';

const PhotoSettings = memo((props: any) => {
  const { questionId, paying, cameraQuality, qualityCamOnChange, tableId } = props;
  const [openedAlert, setOpenedAlert] = useState(false);
  const lang = useLanguage();

  const qualityOptions = [
    {
      value: '1',
      tag: lang.form_builder.high,
      desc: '1 Quality - 1000 Max Height - 1000 Max Width',
      tip: `(${lang.form_builder.photoAlert})`,
    },
    {
      value: '0.8',
      tag: lang.form_builder.mid,
      desc: '0.8 Quality - 800 Max Height - 800 Max Width',
      tip: `(${lang.form_builder.recommended})`,
    },
    {
      value: '0.6',
      tag: lang.form_builder.low,
      desc: '0.6 Quality - 600 Max Height - 600 Max Width',
    },
  ];

  return (
    <div style={{ fontSize: 12 }}>
      <div>
        <FormLabel
          style={{ fontSize: 12, marginBottom: 7 }}
          component='legend'
        >
          {lang.form_builder.camQuality}
        </FormLabel>
        <RadioGroup
          value={qualityOptions.map((o) => o.value).includes(cameraQuality) ? cameraQuality : '0.6'}
          style={{ fontSize: 12 }}
          onChange={(e) => {
            if (paying) qualityCamOnChange(questionId, e.target.value, tableId);
            else setOpenedAlert(true);
          }}
        >
          {qualityOptions.map((option, idx) => (
            <FormControlLabel
              key={idx}
              value={option.value}
              control={
                <Radio
                  size={'small'}
                  style={{ padding: '5px 15px' }}
                  color={'primary'}
                />
              }
              label={
                <Tooltip
                  title={option.desc}
                  placement={'right'}
                >
                  <div style={{ display: 'flex' }}>
                    <div style={{ fontSize: 12 }}>{option.tag}</div>
                    {paying && (
                      <div
                        style={{
                          fontSize: 12,
                          fontStyle: 'italic',
                          color: '#8d8d8d',
                        }}
                      >
                        {option.tip}
                      </div>
                    )}
                  </div>
                </Tooltip>
              }
            />
          ))}
        </RadioGroup>
        <Dialog
          open={openedAlert}
          maxWidth={'xs'}
          onClose={() => setOpenedAlert(false)}
        >
          <DialogContent>
            <DialogContentText>
              <div style={{ textAlign: 'center', fontSize: 14 }}>
                {lang.form_builder.payingAlert}
              </div>
            </DialogContentText>
          </DialogContent>
          <DialogActions style={{ justifyContent: 'center' }}>
            <Button
              onClick={() => setOpenedAlert(false)}
              color={'primary'}
              size={'small'}
              style={{ textTransform: 'capitalize' }}
              variant={'outlined'}
            >
              {lang.form_builder.ok}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </div>
  );
});

export { PhotoSettings };
